module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 一个月的字符串模板 -->\n<div class="cp-one-month-wrap current" data-month="' +
((__t = ( month )) == null ? '' : __t) +
'">\n    <h1 class="cp-month-head">' +
((__t = ( head )) == null ? '' : __t) +
'</h1>\n    <table>\n        <thead class="cp-month-thead">\n            <tr>\n                <td>日</td>\n                <td>一</td>\n                <td>二</td>\n                <td>三</td>\n                <td>四</td>\n                <td>五</td>\n                <td>六</td>\n            </tr>\n        </thead>\n        <tbody>' +
((__t = ( body )) == null ? '' : __t) +
'</tbody>\n    </table>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/hotelCalendarPrice/templates/oneMonthModel.ejs
// module id = 160
// module chunks = 6 20